.b7{overflow:hidden;}